module.exports = __webpack_public_path__ + "img/diagram.ffd483b1.png";